<!-- {{campaign.step2HTMLHeader}} -->
<div [innerHTML]="campaign.step2HTMLHeader" style="margin-bottom: 30px;"></div>
<form [formGroup]="requestTreeForm">
    <!-- <table class="datatable datatableL">
        <tr *ngFor="let requestTreeForm of requestTreeForms.controls; let i = index" [formGroup]="requestTreeForm">
            <td> 
        <div class="col-xm-2"></div>
                 <img id="imgid{{i}}" [src]="getImage(i)" style="height: 120px;" *ngIf="campaign.trees[i].treeBase64Pic !== null"/>
            </td>
            <td>
                <div class="d-flex justify-content-start">
                    <select class="form-control" id="transType" formControlName="qty1" >
                        <option *ngFor="let q of qtys" [ngValue]="q">{{q}}</option>
                      </select>
                      <select class="form-control" id="transType" formControlName="qty2" >
                        <option *ngFor="let q of qtys" [ngValue]="q">{{q}}</option>
                      </select>
                      <select class="form-control" id="transType" formControlName="qty3" >
                        <option *ngFor="let q of qtys" [ngValue]="q">{{q}}</option>
                      </select>
                      <select class="form-control" id="transType" formControlName="qty4" >
                        <option *ngFor="let q of qtys" [ngValue]="q">{{q}}</option>
                      </select>
                </div>
            </td>
        </tr>
    </table> -->
    <div class="row line" *ngFor="let requestTreeForm of requestTreeForms.controls; let i = index;"
        [formGroup]="requestTreeForm">
        <div class="col-sm-auto" style="min-width:300px">
            <h5>{{campaign.trees[i].treeCommonName}}</h5>
            <h6 style="font-style: italic;">{{tree(i).treeSpeciesName}}</h6>
            <img id="imgid{{i}}" [src]="getImage(i)" style="width: 250px;"
                *ngIf="campaign.trees[i].treeBase64Pic !== null" />
        </div>
        <div class="col-sm">
            <div style="color:red;" *ngIf="campaign.trees[i].isWaitlist===1">
                SOLD OUT: You will be waitlisted for this tree(s). Your credit card will only be charged if/when this
                tree becomes available.<br>
            </div>
            <div style="margin-top: 5px;"  *ngIf="campaign.trees[i].isWaitlist===1">
                <p>{{tree(i).treeDescription}}</p>
            </div>
            <div style="margin-top: 50px;"  *ngIf="campaign.trees[i].isWaitlist!==1">
                <p>{{tree(i).treeDescription}}</p>
            </div>
            <p style="color: red;font-size:smaller">{{tree(i).treeSpecialInstruction}}</p>
            <div class="row">
                <div class="col-sm-auto selbox" *ngIf="campaign.trees[i].planting1LocationName!=='Not Used'">
                    <div class="input-group">
                        <select class="form-control form-control-sm drop-box" id="loc{{i}}" formControlName="qty1">
                            <option style="display:none">
                            <option *ngFor="let q of qtys" [ngValue]="q">{{q}}</option>
                        </select>
                        <div class="input-group-append loc">
                            <span class="loc-name">{{campaign.trees[i].planting1LocationName}}</span>
                            <a class="infolink question" ngbPopover="{{campaign.trees[i].planting1LocationHint}}"
                                triggers="click" popoverTitle="Planting Hint" container="body"
                                placement="top-right"></a>
                        </div>
                    </div>
                    <span class="loc-cost">&nbsp;{{getLocationCost(i,1) | currency}}</span>
                </div>
                <div class="col-sm-auto selbox" *ngIf="campaign.trees[i].planting2LocationName!=='Not Used'">
                    <div class="input-group">
                        <select class="form-control form-control-sm drop-box" id="loc{{i}}" formControlName="qty2">
                            <option style="display:none">
                            <option *ngFor="let q of qtys" [ngValue]="q">{{q}}</option>
                        </select>
                        <div class="input-group-append">
                            <span class="loc-name">{{campaign.trees[i].planting2LocationName}}</span>
                            <a class="infolink question" ngbPopover="{{campaign.trees[i].planting2LocationHint}}"
                                triggers="click" popoverTitle="Planting Hint" container="body"></a>
                        </div>
                    </div>
                    <span class="loc-cost">&nbsp;{{getLocationCost(i,2) | currency}}</span>
                </div>
                <div class="col-sm-auto selbox" *ngIf="campaign.trees[i].planting3LocationName!=='Not Used'">
                    <div class="input-group">
                        <select class="form-control form-control-sm drop-box" id="loc{{i}}" formControlName="qty3">
                            <option style="display:none">
                            <option *ngFor="let q of qtys" [ngValue]="q">{{q}}</option>
                        </select>
                        <div class="input-group-append">
                            <span class="loc-name">{{campaign.trees[i].planting3LocationName}}</span>
                            <a class="infolink question" ngbPopover="{{campaign.trees[i].planting3LocationHint}}"
                                triggers="click" popoverTitle="Planting Hint" container="body"></a>
                        </div>
                    </div>
                    <span class="loc-cost">&nbsp;{{getLocationCost(i,3) | currency}}</span>
                </div>
                <div class="col-sm-auto selbox" *ngIf="campaign.trees[i].planting4LocationName!=='Not Used'">
                    <div class="input-group">
                        <select class="form-control form-control-sm drop-box" id="loc{{i}}" formControlName="qty4">
                            <option style="display:none">
                            <option *ngFor="let q of qtys" [ngValue]="q">{{q}}</option>
                        </select>
                        <div class="input-group-append">
                            <span class="loc-name">{{campaign.trees[i].planting4LocationName}}</span>
                            <a class="infolink question" ngbPopover="{{campaign.trees[i].planting4LocationHint}}"
                                triggers="click" popoverTitle="Planting Hint" container="body"></a>
                        </div>
                    </div>
                    <span class="loc-cost">&nbsp;{{getLocationCost(i,4) | currency}}</span>
                </div>
            </div>
        </div>
    </div>
    <div style="max-width: 450px;margin-top: 50px;" *ngIf="campaign.displayIfNotAvailable">
        <div class="form-group">
            <label for="notAvailable" class="control-label">If my species is/are NOT available, I will accept:<span
                    class="req-field"> * </span></label>
            <select class="form-control" id="transType" [formControl]="notAvailableControl">
                <option style="display:none">
                <option *ngFor="let na of notAvails" [ngValue]="na.num">{{na.text}}</option>
            </select>
            <div *ngIf="notAvailableControl.invalid && (notAvailableControl.dirty || notAvailableControl.touched)"
                class="form-text text-danger">
                <div *ngIf="notAvailableControl.errors.required">This answer is required.</div>
            </div>
        </div>
        <div class="form-group" [hidden]="notAvailableControl.value != '2'">
            <label for="notAvailable" class="control-label">Please select all that apply</label>
            <div class="checklist">
                <div *ngFor="let t of campaign.displayNotAvail; let j=index">
                    <div class="form-check">
                        <input type="checkbox" id="want{{j}}" class="form-check-input"
                            [formControl]="myTreesForm.controls[j]">
                        <label class="form-check-label" for="want{{j}}">{{t.treeCommonName}}</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>